module.exports = __webpack_public_path__ + "static/media/exclamation.2780c86d.svg";